import React, { Component } from "react";

const Footer = () => {
  let footer = window["app-config"].ui.footer;

  return (
    <div className="sl__modal-inner">
      <div className="sl__modal--content">
        <div
          className="footer"
          style={{
            width: "100%",
          }}
        >
          <img
            src={process.env.PUBLIC_URL + `/images/${footer.footerImage}`}
            style={{ float: "right" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Footer;
